import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { connect } from "react-redux";
import useStyles from './ResetPasswordConfirmationCardStyles';
import {
    Button,
    Container,
} from '@mui/material';
import { MdDone } from "react-icons/md";
import useHistory from '@/hooks/useHistory';


interface Props {
    settings: any,
}

const ResetPasswordConfirmationCard: React.FC<Props> = props => {

    const { classes, cx } = useStyles();
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateHome = () => {
        let path = `/login`;
        history.push(path);
    }

    return (
        <AuthPage
            title="Your password has been reset successfully!"
            icon={<MdDone />}
            iconTone="ok"
            actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateHome}>Go To Log In</button>}>
            <p>Please proceed and log in with your newly created password.</p>
        </AuthPage>
    )

}


const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(ResetPasswordConfirmationCard);